import type { ContractContext } from './context';
import type { CommandId } from './ids';

export type ConfigActionType =
  | 'initializeConfiguration'
  | 'setAttributeValue'
  | 'unsetAttributeValue'
  | 'selectComponent'
  | 'addChildItem'
  | 'removeChildItem'
  | 'applyPreset'
  | 'resetConfiguration'
  | 'validateConfiguration'
  | 'requestPrice'
  | 'requestAvailability';

export interface ConfigAction<TPayload = Record<string, unknown>> {
  commandId: CommandId;
  type: ConfigActionType;
  payload: TPayload;
  context: ContractContext;
}

export interface SetAttributeValuePayload {
  attributeId: string;
  value: string | number | boolean | string[];
}

export interface UnsetAttributeValuePayload {
  attributeId: string;
}

export interface SelectComponentPayload {
  componentId: string;
  selectedVariantId: string;
}

export interface ResetConfigurationPayload {
  reason?: string;
}

export interface ApplyPresetPayload {
  presetId: string;
  selections: Record<string, unknown>;
}

export interface AddChildItemPayload {
  componentId: string;
  variantId: string;
  position?: number;
}

export interface RemoveChildItemPayload {
  componentId: string;
  itemIndex: number;
}
